module.exports = __webpack_public_path__ + "static/img/dialog1.75ccf65.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/common/dialog1.png
// module id = b6r5
// module chunks = 7